import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { TrackInfo } from "src/app/shared/service/journey/tracks/model/track-info";
import { FormValidations } from "../../../shared/form-validation/form-validation";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { AddressService } from "../../services/address.service";

@Component({
  selector: "app-adjunt",
  templateUrl: "./adjunt.page.html",
  styleUrls: ["./adjunt.page.scss"],
})
export class AdjuntPageComponent
  extends DefaultPageComponent
  implements OnInit
{
  public nameAdjunt = "";
  public idComponentAdjunt = "address-adjunt";
  placeholder = "Ex.: Apto 806";
  error = false;
  buttonEnable = true;
  textError = "";
  invalidErrorText = "Nome inválido";
  idLabel = "page-address-adjunt";
  label = "complemento";
  headerId = "address-adjunt";
  titlePage = "Endereço";
  startStage = "";
  endStage = "";
  analyticsPage: AnalyticsPageModel;

  addressAdjuntForm = this.formBuilder.group({
    adjuntAddress: this.formBuilder.control("", [
      FormValidations.validationsNumberAddressNoRequired,
    ]),
  });

  constructor(
    private formBuilder: FormBuilder,
    public router: NavController,
    public backNativeService: BackNativeService,
    private addressService: AddressService,
    private title: Title,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.analyticsData();
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest("complemento", "adjunct", "address");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "address";

    this.startStage = track.getIndexPage(this.headerId, path).toString();
    this.endStage = track.getTotalPage(path).toString();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.addressAdjunct;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  errorMessage() {
    const control = this.addressAdjuntForm.get("adjuntAddress") as FormControl;
    this.error = control.errors !== null;

    this.error ? (this.buttonEnable = false) : (this.buttonEnable = true);

    if (control.errors !== null && control.errors.hasOwnProperty("repeated")) {
      this.textError = this.invalidErrorText;
    }
    if (control.errors !== null && control.errors.hasOwnProperty("nameSpace")) {
      this.textError = this.invalidErrorText;
    }
  }

  clickNext() {
    this.addressService.setAddressAdjunt(this.nameAdjunt);

    if (!this.addressService.addressInitalPostCode?.district) {
      return this.nextPage();
    } else if (!this.addressService.addressInitalPostCode?.state) {
      return this.router.navigateForward(["address", "state"]);
    } else if (!this.addressService.addressInitalPostCode?.city) {
      return this.router.navigateForward(["address", "city"]);
    } else {
      const track = this.journeyService.selectedTrack.getTrack();
      const indexAdressState =
        track.findIndex((page: TrackInfo) => page.pageId === "address-city") +
        1;
      const path = track[indexAdressState]?.path;

      if (path) {
        this.router.navigateForward(path);
      } else {
        this.endJourney();
      }
    }
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.addressAdjunct,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.address.adjunct) {
      this.nameAdjunt =
        this.journeyService.registratioJourney.data.address.adjunct;
      this.addressAdjuntForm.controls.adjuntAddress.setValue(
        this.journeyService.registratioJourney.data.address.adjunct
      );
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
}
